export default "__VITE_ASSET__h_bCEOw7__"